import * as angular from "angular";
import {HolderType} from "../../commons/types/holder.type";
import {ReminderSettings} from "../models/reminder-settings.model";

export class RemindersDialogsService {

  /* @ngInject */
  constructor(private $mdDialog) {
  }

  createReminder(event, holderType: HolderType) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-reminder-dialog.html').default,
      controller: function ($scope) {
        $scope.header = 'Create New Reminder';
        $scope.action = 'Create';
        $scope.cancel = self.$mdDialog.cancel;
        $scope.reminder = {holderType: holderType}

        // ******************************
        // External methods
        // ******************************

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              self.$mdDialog.hide({reminder: $scope.reminder});
            }

          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  editReminder(event, reminderToEdit: ReminderSettings) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-reminder-dialog.html').default,
      controller: function ($scope) {

        $scope.header = 'Edit Document';
        $scope.action = 'Edit';
        $scope.cancel = self.$mdDialog.cancel;
        $scope.reminder = reminderToEdit

        // ******************************
        // External methods
        // ******************************

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              self.$mdDialog.hide({reminder: $scope.reminder});
            }

          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

}

angular
  .module('bringoz.admin.site-preferences')
  .service('remindersDialogsService', RemindersDialogsService);
